import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class SevenButtons extends DesigntimeComponent {
    static staticName = "Buttons (1-7)";
    static staticId = "sevenButtons";
    runtimeValue = 1;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            text: { value: "text" },
            lowText: { value: "Completely disagree" },
            highText: { value: "Completely agree" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var $view = $("<div class='sid-clearfix'></div>");

        var $text = $("<div class='sid-question-text'></div>");
        $text.append($("<h3>" + this.values.text.value + "<h3>"));
        $view.append($text);

        var $buttons = $("<div class='button-row'></div>")
        var $fieldset = $("<fieldset class='button-row-fieldset'></fieldset>");
        for (var i = 1; i < 8; i++) {
            var $button = $("<div class='sid-row-button' data-index='" + i + "'>" + i + "</div>");
            $button.click(function (e) {
                componentHelpers.getRtFrame(this.id).find(".sid-row-button").removeClass("sid-button-selected");
                $(e.currentTarget).addClass("sid-button-selected");
                this.runtimeValue = $(e.currentTarget).data("index");
                this.enableNextButton();
            }.bind(this));
            $fieldset.append($button);
        }
        $buttons.append($fieldset);
        $view.append($buttons);

        var $leftText = $("<div class='button-row-under-left'></div>")
        $leftText.append($("<p>" + this.values.lowText.value + "</p>"))
        $view.append($leftText);

        var $rightText = $("<div class='button-row-under-right'></div>")
        $rightText.append($("<p>" + this.values.highText.value + "</p>"))
        $view.append($rightText);

        return $view;
    }

    getOutput() {
        return {
            value: this.runtimeValue,
        };
    }

    output = [
        { name: "value", type: "int" }
    ];
}

export { SevenButtons }
